enum RevalidationTag {
  /**
   * Revalidates the whole cache.
   */
  all = 'all',
  pages = 'pages',
  data = 'data',
  locales = 'locales',
  businessContext = 'businessContext',
  oleInfos = 'oleInfos',
  blogPosts = 'blogPosts',
  globalSections = 'globalSections',
  brands = 'brands',
  producers = 'producers',
  caseStudies = 'caseStudies',
  markets = 'markets',
  technologies = 'technologies',
  products = 'products',
  redirects = 'redirects',
  translations = 'translations',
  featureToggles = 'featureToggles'
}

export default RevalidationTag;
